import axios from "axios";
import { ApiReqBaseUrl } from "../assets/GlobalVariables";
import { attachAgentSessionToBody } from "./agentApiSession";
import {
  resolveDynamicOrdersFetchDecision,
  emptyAxiosOrdersListEnvelope,
} from "../features/orders/ldsOrdersEntitlementGuard.js";

export const saveDynamicPackage = async (data) => {
  return await axios.post(
    `${ApiReqBaseUrl}/saveDynamicPackage`,
    attachAgentSessionToBody(data),
    { withCredentials: true },
  );
};

/** flights_new_proposal dynamic row: record bank transfer, no card / no LDS BOOK */
export const postFlightsNewProposalBankTransfer = async (payload) => {
  return axios.post(`${ApiReqBaseUrl}/flightsNewProposalBankTransfer`, payload);
};

export const postRetryLdsFlightsProposal = async (payload) => {
  return axios.post(`${ApiReqBaseUrl}/retryLdsFlightsProposal`, payload);
};

export const getDynamicOrder = async (data) => {
  return await axios.post(`${ApiReqBaseUrl}/getDynamicOrder`, data);
};

export const getDynamicOrders = async (data, ldsEntitlementsCtx = undefined) => {
  const endpoint = `${ApiReqBaseUrl}/getDynamicOrdersByAgentId`;
  const decision = resolveDynamicOrdersFetchDecision(
    ldsEntitlementsCtx && typeof ldsEntitlementsCtx === "object"
      ? ldsEntitlementsCtx
      : {},
    endpoint
  );
  if (decision.skipFetch) {
    return emptyAxiosOrdersListEnvelope(data?.page, data?.size);
  }
  try {
    return await axios.post(endpoint, data);
  } catch (err) {
    const st = err?.response?.status;
    const raw = err?.response?.data;
    const msg = String(raw?.message ?? raw?.error ?? err?.message ?? "").toLowerCase();
    const entitlement403 =
      st === 403 && (msg.includes("entitlement") || msg.includes("forbidden"));
    if (entitlement403) {
      if (typeof import.meta !== "undefined" && import.meta.env?.DEV) {
        console.info("[getDynamicOrders] 403 entitlement — empty list fallback");
      }
      return emptyAxiosOrdersListEnvelope(data?.page, data?.size);
    }
    console.log({ err });
  }
};

export const getDynamicHotelNames = async (agent_id) => {
  try {
    const response = await axios.post(
      `${ApiReqBaseUrl}/getDynamicHotelNames`,
      { agent_id },
      {
        responseType: "text",
        transformResponse: [(data) => data],
        validateStatus: () => true,
      }
    );
    if (response.status < 200 || response.status >= 300) {
      return { data: [] };
    }
    if (Array.isArray(response.data)) {
      return { data: response.data };
    }
    if (typeof response.data === "string") {
      try {
        const parsed = JSON.parse(response.data);
        if (Array.isArray(parsed)) return { data: parsed };
        if (Array.isArray(parsed?.data)) return { data: parsed.data };
        return { data: [] };
      } catch {
        return { data: [] };
      }
    }
    if (Array.isArray(response.data?.data)) {
      return { data: response.data.data };
    }
    return { data: [] };
  } catch (err) {
    console.log({ err });
    return { data: [] };
  }
};

export const getDynamicAgentEmails = async () => {
  try {
    const response = await axios.post(
      `${ApiReqBaseUrl}/getDynamicAgentEmails`,
      {},
      {
        responseType: "text",
        transformResponse: [(data) => data],
        validateStatus: () => true,
      }
    );
    if (response.status < 200 || response.status >= 300) {
      return { data: [] };
    }
    if (Array.isArray(response.data)) {
      return { data: response.data };
    }
    if (typeof response.data === "string") {
      try {
        const parsed = JSON.parse(response.data);
        if (Array.isArray(parsed)) return { data: parsed };
        if (Array.isArray(parsed?.data)) return { data: parsed.data };
        return { data: [] };
      } catch {
        return { data: [] };
      }
    }
    if (Array.isArray(response.data?.data)) {
      return { data: response.data.data };
    }
    return { data: [] };
  } catch (err) {
    console.log({ err });
    return { data: [] };
  }
};
